<mat-card>
    <h4>{{'REGISTER.PROFILE' | translate}}:</h4>
    <div class="pt-3">
      <div class="proflie-field mb-3">
        <label>{{'REGISTER.FIRST_NAME' | translate}}:</label>
        <span>{{userLogged?.name}}</span>
      </div>
      <div class="proflie-field mb-3">
        <label>{{'REGISTER.LAST_NAME' | translate}}:</label>
        <span>{{userLogged?.surname}}</span>
      </div>
      <div class="proflie-field mb-3">
        <label>{{'REGISTER.EMAIL' | translate}}:</label>
        <span>{{userLogged?.email}}</span>
      </div>
      <div class="proflie-field mb-3">
        <label>{{'REGISTER.USERNAME' | translate}}:</label>
        <span>{{userLogged?.username}}</span>
      </div>
      <div class="proflie-field mb-3">
        <label>{{'REGISTER.MOBILE_NUMBER' | translate}}:</label>
        <span>{{userLogged?.phoneNumber}}</span>
      </div>  
      <button mat-raised-button color="accent"  >
        <a [routerLink]="['/auth/account/edit-profile']">
          {{'REGISTER.EDIT' | translate}}
        </a>
      </button>
    </div>
  </mat-card>
  